module.exports = __webpack_public_path__ + "static/img/2.c213d9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/2.jpg
// module id = r5hf
// module chunks = 0